import axios from 'axios'
import { API } from '@/utils'
import { ICourse } from '@/types'

export async function getLegacyCourses(): Promise<ICourse[]> {
    const response = await axios.get(API('courses/get_legacy_courses'))
    return response.data
}